import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import useLanguageTranslate from "../../../../hooks/useLanguageTranslate";
import usePersonalAccidentFlow from "../../../../hooks/usePersonalAccidentFlow";
import { STEP_NAME_START } from "../../../../hooks/data";
import usePersonalAccidentFormData from "../../../../hooks/usePersonalAccidentFormData";
import { selectLoginTokenInfo } from "../../../../redux/features/loginRegisterSlice";
import BasicInfo from "../../../common/BasicInfo/BasicInfo";
import BottomStickyBtnLayout from "../../layouts/BottomStickyBtnLayout";
import PersonalAccidentJourneyLayout from "../../layouts/PersonalAccidentJourneyLayout";
import DocumentsReadyInfo from "./documentsReadyInfo/documentsReadyInfo";
import "./startPage.css";

const PERSONAL_ACCIDENT_BASIC_INFO = "PERSONAL_ACCIDENT_BASIC_INFO";

const StartPage = ({ onClose }) => {
  const { handleNextSubstep, currentSubstepIndex, currentStep, handlePrevSubstep } =
    usePersonalAccidentFlow();
  const loginTokenInfo = useSelector(selectLoginTokenInfo);
  const isLoggedIn = !!loginTokenInfo;
  const translate = useLanguageTranslate();

  // Form data hook for saving basic info
  const { savePersonalAccidentDataInRedux, redux_form_data: savedBasicInfo } = usePersonalAccidentFormData(
    PERSONAL_ACCIDENT_BASIC_INFO,
    () => {}
  );

  // Convert Redux data to BasicInfo format
  const initialValues = useMemo(() => {
    if (!savedBasicInfo) return null;
    const birthDateParts = savedBasicInfo.birthDate?.split("-") || [];
    return {
      fullName: savedBasicInfo.fullName || "",
      email: savedBasicInfo.email || "",
      mobile: savedBasicInfo.contactNumber || "",
      year: birthDateParts[0] || "",
      month: birthDateParts[1] || "",
      day: birthDateParts[2] || "",
      fullDate: savedBasicInfo.birthDate || "",
    };
  }, [savedBasicInfo]);

  // If logged in, skip to documents ready step
  useEffect(() => {
    if (
      isLoggedIn &&
      currentStep?.name === STEP_NAME_START &&
      currentSubstepIndex !== 1
    ) {
      handleNextSubstep();
    }
  }, [isLoggedIn, currentStep, currentSubstepIndex, handleNextSubstep]);

  const handleBackToForm = () => {
    handlePrevSubstep();
  };

  const handleSaveBasicInfo = async (basicInfo) => {
    // Save basic info to Redux for use in API calls
    console.log("Personal Accident Basic Info:", basicInfo);
    await savePersonalAccidentDataInRedux(basicInfo);
  };

  return (
    <div className="flex flex-col items-center gap-6 bg-white">
      {isLoggedIn ? (
        currentSubstepIndex === 1 ? (
          <DocumentsReadyInfo
            continueClickHandler={handleNextSubstep}
            hide_back_btn={true}
            show_close_btn={true}
            onClose={onClose}
            isFirstPage={true}
          />
        ) : (
          <div className="p-4">Loading...</div>
        )
      ) : (
        <>
          {currentSubstepIndex === 0 ? (
            <BasicInfo
              continueClickHandler={handleNextSubstep}
              onClose={onClose}
              title={translate(
                "New Personal Accident Insurance",
                "تأمين الحوادث الشخصية"
              )}
              subtitle={translate(
                "Welcome! Let's start with some basic information.",
                "مرحبًا بك! لنبدأ ببعض المعلومات الأساسية."
              )}
              onSaveBasicInfo={handleSaveBasicInfo}
              JourneyLayoutComponent={PersonalAccidentJourneyLayout}
              BottomStickyBtnLayoutComponent={BottomStickyBtnLayout}
              initialValues={initialValues}
              storageKey="personal_accident_basic_info"
            />
          ) : currentSubstepIndex === 1 ? (
            <DocumentsReadyInfo
              continueClickHandler={handleNextSubstep}
              hide_back_btn={false}
              show_close_btn={false}
              onClose={onClose}
              customBackHandler={handleBackToForm}
              isFirstPage={false}
            />
          ) : (
            <div className="p-4">Loading...</div>
          )}
        </>
      )}
    </div>
  );
};

export default StartPage;
